const _accordionDetailsDefaultStyle = theme => ({
  fontFamily: theme.tokens.ComponentAccordionFontName,
  paddingTop: '8px',
  paddingBottom: '8px'
});
const _variants = (theme, contained) => ({
  ...(contained ? {
    paddingRight: '16px',
    paddingLeft: '16px'
  } : {
    paddingLeft: '4px',
    paddingRight: '4px'
  })
});
const accordionDetailsDefaultStyle = (theme, contained) => ({
  ..._accordionDetailsDefaultStyle(theme),
  ..._variants(theme, contained)
});
export default accordionDetailsDefaultStyle;